/**
 * Obtiene el variant del Badge de Bootstrap según el nivel de confianza
 * @param level - Nivel de confianza (HIGH, MEDIUM, LOW)
 * @returns Variant del Badge ('success', 'warning', 'danger')
 */
export const getConfidenceBadgeVariant = (
  level: string
): 'success' | 'warning' | 'danger' => {
  switch (level) {
    case 'HIGH':
      return 'success';
    case 'MEDIUM':
      return 'warning';
    default:
      return 'danger';
  }
};

